import * as TWEEN from '@tweenjs/tween.js';
import mapboxgl = require('mapbox-gl');
import timeSpace = require('@mapbox/timespace');
import { events, defines } from '../base';
import { ThreeView, webcadDefines, View3dGlobal } from './index';
import * as webcad from '../../webcad';
import {WalkThroughCameraControl} from '../base/View3dCamera';
import * as pixelstreamingCommand from '../../pixelstreaming/commands';
import PSSceneManagement from './PSSceneManagemant';

/* WebCadMenus
 * WebCadのメニュー処理用.
 */
export default class WebCadMenus {
  private _eventDispatcher: events.EventDispatcher; // introduce as member

  private mapBoxElement: mapboxgl.Map = null;

  private mapBoxMarker: mapboxgl.Marker = null;

  private placeDateStatus: pixelstreamingCommand.placeDateStatus = new pixelstreamingCommand.placeDateStatus();

  private lightSetting: pixelstreamingCommand.lightSetting = new pixelstreamingCommand.lightSetting();

  public get eventDispatcher() {
    return this._eventDispatcher;
  }

  private _opeMode: defines.OpeMode;

  public get opeMode(): defines.OpeMode {
    return this._opeMode;
  }

  // access limited from ThreeView
  public set opeMode(mode: defines.OpeMode) {
    this._opeMode = mode;
  }

  constructor(eventDispatcher?: events.EventDispatcher) {
    this._eventDispatcher = eventDispatcher;
    //   this.setUpMenus();
    this.bindMenus();
  }

  private _itemDisplaySettings: any[];

  public set itemDisplaySettings(settings) {
    this._itemDisplaySettings = [];
    for (let i = 0; i < settings.length; i += 1) {
      const partType = {
        id: settings[i].id,
        en: settings[i].en,
        jp: settings[i].jp,
        visible: settings[i].visible,
      };
      this._itemDisplaySettings.push(partType);
    }
  }

  public get itemDisplaySettings() {
    return this._itemDisplaySettings;
  }

  /* reset
   * リセット.
   */
  public reset(options: defines.Options) {
    console.log(options);
    this.adjustMenus();
  }

  /* bindMenus
   * menuアイテムの連結.
   */
  private bindMenus() {
    // カメラ切り替えメニューとのバインド.
    this.cameraSwitcher();

    // 表示階切替えメニューとのバインド
    document.querySelector('#show1F_3d').addEventListener('click', this.show1F);
    document.querySelector('#show2F_3d').addEventListener('click', this.show2F);
    document.querySelector('#show3F_3d').addEventListener('click', this.show3F);
    document.querySelector('#showAll_3d').addEventListener('click', this.showAll);
    document.querySelector('#btnMeasureLine3D').addEventListener('click', this.toggleMesureLines);
    document.querySelector('#displayItem').nextElementSibling.addEventListener('click', this.toggleItemDisplay);

    // 視点の浮揚メニューとのバインド
    document.querySelector('#show1F_3dwt').addEventListener('click', this.levitateTo1F);
    document.querySelector('#show2F_3dwt').addEventListener('click', this.levitateTo2F);
    document.querySelector('#show3F_3dwt').addEventListener('click', this.levitateTo3F);

    document.querySelector('#apprWireframe').addEventListener('click', this.toggleWireframes);
    document.querySelector('#apprDiagonal').addEventListener('click', this.toggleSetbacks);
    document.querySelector('#captureScreenshot').addEventListener('click', this.captureScreenshot);

    // ビューモード/選択モード切り替え
    document.querySelectorAll('.changeModeToggleBtn.menuRight').forEach((element) => element.addEventListener('click', this.changeControlMode));

    //pixelstreaming スナップショット
    document.getElementById('movieSnapBtn').addEventListener('click', () => {
        new PSSceneManagement().getImage();
    });
    // 日付変更
    document.getElementById('movieDayDate').addEventListener('change', this.changeDayTimeData);
    this.initDay();
    // 時刻変更
    document.getElementById('timeSettingSlider').addEventListener('input', this.changeDayTimeData);
    // 地図の生成と場所の設定
    document.getElementById('placeSettingBtn').addEventListener('click', this.createMap);
    // 現在時刻の取得
    document.getElementById('setCurrentTimeBtn').addEventListener('click', this.clickCurrentTime);
    // 明るさ変更
    document.getElementById('lightSettingSlider').addEventListener('input', this.changeLightSetting);
    // 色見変更
    document.getElementById('colorSettingSlider').addEventListener('input', this.changeLightSetting);

    // toolTip形式の設定メニューの表示/非表示
    document.querySelectorAll('.footerMenuMovieModeWrap .settingMenuWrap button').forEach((element) => {
      element.addEventListener('click', this.clickToolTipOpenBtn);
    });
  }

  /**
   * 計測ツールの表示切替
   */
  private setMeasureElements(value : boolean):void {
    if ( value ){
      document.getElementById('btnMesureParent').style.display = 'block';
    } else {
      document.getElementById('btnMesureParent').style.display = 'none';
      const mesureInfo = document.getElementById('mesureInfo');
      if (mesureInfo) {
        mesureInfo.style.display = 'none';
      }
      if (ThreeView.get().measureTool) {
        ThreeView.get().measureTool.resetTool();
      }
    }
  }

  /**
   * 内観切り替え
   */
  public walkthroughCamera = () => {
    TWEEN.removeAll();
    ThreeView.get().cameras.no = defines.CameraDefs.wlkthCamNo;
    ThreeView.get().updateView();

    // 表示中のダイアログを消す
    webcad.WebCADGlobal.removeDialog();

    // 表示中の左メニューを閉じる
    webcad.WebCADGlobal.itemChangeMenuCategories3d.reset();

    // 計測ボタン類
    this.setMeasureElements(true);
  }

  /* cameraSwitcher
   * カメラの切替.
   */
  private cameraSwitcher = () => {
    document.getElementById('btnOrbitCamera').addEventListener('click', () => {
      ThreeView.get().opeMode = defines.OpeMode.operate; // カメラ切り替えで確実に操作可能に.

      TWEEN.removeAll();
      ThreeView.get().cameras.no = defines.CameraDefs.orbitCamNo;
      ThreeView.get().updateView();

      ThreeView.get().ItemDragManager.resetController(); // コントローラーの削除

      // 表示中のダイアログを消す
      webcad.WebCADGlobal.removeDialog();

      // 表示中の左メニューを閉じる
      webcad.WebCADGlobal.itemChangeMenuCategories3d.reset();

      // 計測ボタン類
      this.setMeasureElements(false);
    });

    document.querySelector('#btnWalkthroughCamera').addEventListener('click', this.walkthroughCamera);

    document.querySelector('#btnOrbitCameraToggle').addEventListener('click', () => {
      if (ThreeView.get().menus.itemDisplaySettings && ThreeView.get().menus.itemDisplaySettings.length > 0) {
        View3dGlobal.shared.partType = ThreeView.get().menus.itemDisplaySettings;
        ThreeView.get().menus.itemDisplaySettings = [];
      }
      View3dGlobal.shared.setItemDisplay();

      ThreeView.get().opeMode = defines.OpeMode.operate; // カメラ切り替えで確実に操作可能に.

      TWEEN.removeAll();
      ThreeView.get().cameras.no = defines.CameraDefs.orbitCamNo;
      ThreeView.get().updateView();

      ThreeView.get().ItemDragManager.resetController();      // コントローラーの削除

      // 表示中のダイアログを消す
      webcad.WebCADGlobal.removeDialog();

      // 表示中の左メニューを閉じる
      webcad.WebCADGlobal.itemChangeMenuCategories3d.reset();

      // 計測ボタン類
      this.setMeasureElements(false);
    });

    document.querySelector('#btnWalkthroughCameraToggle').addEventListener('click', () => {
      ThreeView.get().menus.itemDisplaySettings = View3dGlobal.shared.partType;
      for (let j = 0, len = View3dGlobal.shared.partType.length; j < len; j += 1) {
        View3dGlobal.shared.partType[j].visible = true;
      }
      View3dGlobal.shared.setItemDisplay();

      TWEEN.removeAll();
      ThreeView.get().cameras.no = defines.CameraDefs.wlkthCamNo;
      ThreeView.get().updateView();

      // 表示中のダイアログを消す
      webcad.WebCADGlobal.removeDialog();

      // 表示中の左メニューを閉じる
      webcad.WebCADGlobal.itemChangeMenuCategories3d.reset();

      // 計測ボタン類
      this.setMeasureElements(true);
    });
  };

  /* show1F
   * 1Fの表示.
   */
  private show1F = () => {
    ThreeView.get().showFloor(1, true);
  };

  /* show2F
   * 2Fの表示.
   */
  private show2F = () => {
    ThreeView.get().showFloor(2, true);
  };

  /* show3F
   * 3Fの表示.
   */
  private show3F = () => {
    ThreeView.get().showFloor(3, true);
  };

  /* showAll
   * すべて表示.
   */
  private showAll = () => {
    ThreeView.get().showFloor(webcadDefines.Limits.roofNo, true);
  };

  /* levitateTo1F
   * 1Fへの浮揚.
   */
  private levitateTo1F = () => {
    ThreeView.get().levitateTo(1);
  };

  /* levitateTo2F
   * 2Fの浮揚.
   */
  private levitateTo2F = () => {
    ThreeView.get().levitateTo(2);
  };

  /* levitateTo3F
   * 3Fの浮揚.
   */
  private levitateTo3F = () => {
    ThreeView.get().levitateTo(3);
  };

  /* toggleMesureLines
   * 寸法線の表示非表示.
   */
  private toggleMesureLines = () => {
    ThreeView.get().toggleMesureLines();
  };

  /* toggleItemDisplay
   * アイテムの表示非表示.
   */
  private toggleItemDisplay = (e: Event) => {
    e.preventDefault();
    ThreeView.get().menus.setItemDisplayButtonStatus();
    webcad.WebCADGlobal.showDialog(webcad.view.dialog.Item3dDisplayDialog, true);
  };

  /**
   * アイテムの表示非表示. button class
   */
  public setItemDisplayButtonStatus = () => {
    if (View3dGlobal.shared.isAllItemVisible()) {
      if ((<HTMLInputElement>document.getElementById('displayItem')).checked) {
        (<HTMLInputElement>document.getElementById('displayItem')).checked = false;
      }
    } else if (!(<HTMLInputElement>document.getElementById('displayItem')).checked) (<HTMLInputElement>document.getElementById('displayItem')).checked = true;
  };

  /* toggleNightDay
   */
  private toggleNightDay = () => {
    const state = (<HTMLInputElement>document.querySelector('#apprNight')).checked;
    View3dGlobal.shared.nighttime = !state;
    (<HTMLInputElement>document.querySelector('#apprNightWt')).checked = View3dGlobal.shared.nighttime;
  };

  /* toggleWireframes
   * ワイヤフレームの表示非表示.
   */
  private toggleWireframes = () => {
    ThreeView.get().toggleWireframes();
  };

  /* toggleSetbacks
   * 斜線規制の表示非表示.
   */
  private toggleSetbacks = () => {
    // 敷地がない場合はアラートを表示して実行しない
    const itemList = webcad.WebCADGlobal.layerGroup.getAllItems();
    for (let i = 0, len = itemList.length; i < len; i += 1) {
      if (itemList[i] instanceof webcad.item.Site) {
        ThreeView.get().toggleSetbacks();
        return;
      }
      // continue;
    }
    // 敷地の入力が必要です。<br>2Dモードで敷地を入力してからお試しください。
    webcad.WebCADGlobal.showAlert(webcad.collection.WebCADMessages.getText('ERROR_NEED_SITE'));
    // ボタンの表示を元に戻す
    (<HTMLInputElement>document.querySelector('#apprDiagonal')).checked = false;
  };

  /* adjustMenus
   * メニュの表示調整.
   */
  public adjustMenus(eventName?: string): void {
    if (eventName === undefined || eventName === defines.EventNames.wtPointChanged || eventName === webcadDefines.WebCadEventNames.wtFloorChanged) {
      const { floor } = ThreeView.get().wcCameras;
      (<HTMLInputElement>document.querySelector('#radiofloor1_3dwt')).checked = floor === 1;
      (<HTMLInputElement>document.querySelector('#radiofloor2_3dwt')).checked = floor === 2;
      (<HTMLInputElement>document.querySelector('#radiofloor3_3dwt')).checked = floor === 3;
    }
    if (eventName === undefined || eventName === webcadDefines.WebCadEventNames.obFloorVisChanged) {
      const floor = ThreeView.get().wcItemmgr.getFloorShown();
      (<HTMLInputElement>document.querySelector('#radiofloor1_3d')).checked = floor === 1;
      (<HTMLInputElement>document.querySelector('#radiofloor2_3d')).checked = floor === 2;
      (<HTMLInputElement>document.querySelector('#radiofloor3_3d')).checked = floor === 3;
      (<HTMLInputElement>document.querySelector('#radiofloorAll_3d')).checked = floor > webcadDefines.Limits.maxFloor;
    }
    if (eventName === undefined || eventName === webcadDefines.WebCadEventNames.wireframeModeChanged) {
      const vis = ThreeView.get().wcItemmgr.wireframe;
      (<HTMLInputElement>document.querySelector('#apprWireframe')).checked = vis;
    }
    if (eventName === undefined || eventName === webcadDefines.WebCadEventNames.setbackModeChanged) {
      const vis = ThreeView.get().wcItemmgr.setbackObjects.visible;
      (<HTMLInputElement>document.querySelector('#apprDiagonal')).checked = vis;
    }
    if (eventName === undefined || eventName === webcadDefines.WebCadEventNames.sizeObjectVisible) {
      const vis = ThreeView.get().wcItemmgr.sizesObjects.visible;
      (<HTMLInputElement>document.querySelector('#apprMeasure')).checked = vis;
    }
    this.setItemDisplayButtonStatus();
  }

  // スクリーンショットをキャプチャする
  private captureScreenshot = () => {
    ThreeView.get().saveViewAsImage();
  };

  // ビューモード/選択モードの切り替え
  private changeControlMode = () => {
    const wrkth = ThreeView.get().wcCameras.getCamera(defines.CameraDefs.wlkthCamNo);
    const control = <WalkThroughCameraControl>wrkth.control;

    const isNaikanMode = webcad.WebCADGlobal.isViewCameraMode == false;

    control._instance.setEnabled(isNaikanMode); // WalkThroughControls enabled 切り替え
    // ボタンの切り替え
    document.getElementById('btnSelectModeToggle').style.display = isNaikanMode ? 'none' : 'flex';
    document.getElementById('btnViewModeToggle').style.display = isNaikanMode ? 'flex' : 'none';
    document.getElementById('btneMesure').style.display = isNaikanMode ? 'block' : 'none';
    
    // 内観モード
    if (isNaikanMode) {      
      // カーソルを手のマークに戻す
      $('#webcad3dView').css('cursor', `url(${webcad.WebCADGlobal.webcad2Dmanager.assets_url}img/grab.cur), move`);
    }
    // カメラモードの反転
    webcad.WebCADGlobal.isViewCameraMode = !webcad.WebCADGlobal.isViewCameraMode;
  }

  private sendObject = (object) => {
    ThreeView.get().pscommunication.send(object);
  }

  // 日時の変更
  private changeDayTimeData = (e) => {
    e.preventDefault();
    // 時間
    const time = (document.getElementById('timeSettingSlider') as HTMLInputElement).value;
    this.updateCurrentTime(Number(time));
    if (!(document.getElementById('movieDayDate') as HTMLInputElement).value) {
      (document.querySelector('.footerMenuMovieModeWrap .daySettingError') as HTMLElement).style.visibility = 'visible';
      return;
    }
    (document.querySelector('.footerMenuMovieModeWrap .daySettingError') as HTMLElement).style.visibility = 'hidden';
    // 日付
    const day = (document.getElementById('movieDayDate') as HTMLInputElement).value.replace(/-/g, '/');
    ThreeView.get().dayTime = `${day} ${time}:00`;
    this.placeDateStatus.setDate(ThreeView.get().dayTime);
    this.sendObject(this.placeDateStatus.object());
    console.log(`日時 ${ThreeView.get().dayTime}`);
  }

  // 日時のツールチップ更新
  private updateCurrentTime = (time: number) => {
    document.querySelector('.timeSettingSliderOutPut').innerHTML = `${time}:00`;
    (document.querySelector('.timeSettingSliderOutPut') as HTMLElement).style.left = `calc(${((time - 4) * 100) / (22 - 4)}% + (${10.25 - (((time - 4) * 100) / (22 - 4)) * 0.2}px))`;
  }

  // 現在日時の取得
  private clickCurrentTime = (e) => {
    e.preventDefault();
    const data = new Date();
    let dayValue = '';
    dayValue += data.getFullYear();
    dayValue += `-${(data.getMonth() + 1).toString().padStart(2, '0')}`;
    dayValue += `-${data.getDate().toString().padStart(2, '0')}`;
    (document.getElementById('movieDayDate') as HTMLInputElement).value = dayValue;
    (document.getElementById('timeSettingSlider') as HTMLInputElement).value = data.getHours().toString();
    this.updateCurrentTime(data.getHours());
    this.changeDayTimeData(e);
  }

  // 日付の初期化
  private initDay = () => {
    const data = new Date();
    let dayValue = '';
    dayValue += data.getFullYear();
    dayValue += `-${(data.getMonth() + 1).toString().padStart(2, '0')}`;
    dayValue += `-${data.getDate().toString().padStart(2, '0')}`;
    (document.getElementById('movieDayDate') as HTMLInputElement).value = dayValue;
    this.updateCurrentTime(9);
  }

  // 地図の生成
  private createMap = (e) => {
    e.preventDefault();
    // 地図生成
    this.mapBoxElement = new mapboxgl.Map({
      accessToken: 'pk.eyJ1IjoidGFrYTMxMzMiLCJhIjoiY2w5Nmg5aG53MmJhNTNvbGY5cDJiaXpvNyJ9.SiTVzkBvcHjIQ18X9lFgmA',
      container: 'mapBox',
      style: 'mapbox://styles/taka3133/cl96rxxja000b15mep542kcew',
      zoom: 5,
      center: [ThreeView.get().placeData.longitude, ThreeView.get().placeData.latitude],
    });
    // マーカーの追加
    this.mapBoxMarker = new mapboxgl.Marker({ color: '#FF0000' }).setLngLat([ThreeView.get().placeData.longitude, ThreeView.get().placeData.latitude]).addTo(this.mapBoxElement);
    this.mapBoxMarker.getElement().style.pointerEvents = 'none';
    document.querySelector('.placeSettingMap').appendChild(this.mapBoxElement.getContainer());
    // 言語設定
    this.mapBoxElement.on('load', () => {
      const labels = [
        'country-label', 'state-label', 'settlement-minor-label', 'settlement-major-label',
        'settlement-subdivision-label', 'airport-label', 'poi-label', 'water-point-label',
        'water-line-label', 'natural-point-label', 'natural-line-label', 'waterway-label', 'road-label',
      ];
      labels.forEach((label) => {
        this.mapBoxElement.setLayoutProperty(label, 'text-field', ['get', 'name_ja']);
      });
    });
    (this.mapBoxElement.getContainer().querySelector('.mapboxgl-control-container') as HTMLElement).style.display = 'none';
    document.getElementById('placeSettingBtn').removeEventListener('click', this.createMap);
    this.mapBoxElement.on('click', this.clickMap);
  }

  // mapをクリック時
  private clickMap = (e) => {
    e.preventDefault();
    // ピンの位置調整
    this.mapBoxMarker.setLngLat([e.lngLat.lng, e.lngLat.lat]);

    if (!(document.getElementById('movieDayDate') as HTMLInputElement).value) return;
    // タイムゾーンの取得
    const timestamp = new Date((document.getElementById('movieDayDate') as HTMLInputElement).value);
    const point = [e.lngLat.lng, e.lngLat.lat];
    // 領海以外の海や南極大陸/北極等はタイムゾーンが取得できないため、経度を参考に0.25刻みで疑似的なタイムゾーンを算出する
    const timezone = timeSpace.getFuzzyLocalTimeFromPoint(timestamp, point) ? (timeSpace.getFuzzyLocalTimeFromPoint(timestamp, point).utcOffset() / 60) : (Math.round((e.lngLat.lng / 15) * 4) / 4);
    // 位置情報＋タイムゾーンの更新
    const day = (document.getElementById('movieDayDate') as HTMLInputElement).value.replace(/-/g, '/');
    const time = (document.getElementById('timeSettingSlider') as HTMLInputElement).value;
    ThreeView.get().dayTime = `${day} ${time}:00`;
    this.placeDateStatus.setDate(ThreeView.get().dayTime);
    ThreeView.get().placeData = { longitude: e.lngLat.lng, latitude: e.lngLat.lat, timezone };
    this.placeDateStatus.setPlace(ThreeView.get().placeData.longitude, ThreeView.get().placeData.latitude, ThreeView.get().placeData.timezone);
    this.sendObject(this.placeDateStatus.object());
    console.log(`場所：  経度 ${ThreeView.get().placeData.longitude}  緯度 ${ThreeView.get().placeData.latitude}  タイムゾーン ${ThreeView.get().placeData.timezone}`);
  }

  // 明るさと色見の変更
  private changeLightSetting = (e) => {
    e.preventDefault();
    const intensity = (Number((document.getElementById('lightSettingSlider') as HTMLInputElement).value) / 100);
    const temperature = Number((document.getElementById('colorSettingSlider') as HTMLInputElement).value);
    ThreeView.get().lightSetting = { intensity, temperature };
    this.lightSetting.setLight(ThreeView.get().lightSetting.intensity, ThreeView.get().lightSetting.temperature);
    this.sendObject(this.lightSetting.object());
    console.log(`ライト：  明るさ ${intensity}  色見 ${temperature}`);
  }

  // toolTip形式の設定メニューの表示/非表示
  private clickToolTipOpenBtn = (e) => {
    // toolTip以外のDOM操作時に非表示に
    const toolTipReset = (e2) => {
      const parent = (e2.target as HTMLElement).closest('.settingMenuWrap');
      if (parent && parent.classList.contains('toolTipActive')) return;
      document.querySelectorAll('.footerMenuMovieModeWrap .settingMenuWrap').forEach((element) => {
        element.classList.remove('toolTipActive');
      });
      document.removeEventListener('mousedown', toolTipReset);
    };
    // toolTipを表示
    const parent = (e.target as HTMLElement).closest('.settingMenuWrap');
    if (!parent.classList.contains('toolTipActive')) {
      parent.classList.add('toolTipActive');
      document.addEventListener('mousedown', toolTipReset);
    }
  }
}
